import React from "react";
import {NumericFormat} from 'react-number-format';
import { PatternFormat } from 'react-number-format';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import {styled} from "@mui/material/styles";
import * as font from "../utilities/fontUtilities";
import * as ddo from "../constants/customObjConstants";
import * as tag from "../constants/customMetadataConstants";
import * as portalShared from "../shared/metadataConstantsAndUtilities"
import * as requiredUtil from "../utilities/requiredUtilities";
import {singleSelectDropDown} from "./SingleSelect";



// |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||
// ---------------------------------------------------------------------------------------------------------------------
//<editor-fold desc="[CODE SECTION] Text Question Save Answer Routines ----------------------------------------------------------------------">

const LABEL_ABOVE = "above";
const LABEL_BELOW = "below";


function saveAnswerTypeText(callerRefStr, savedObjs, event) {

    const {
        question,
        surveyEditMode,
        displayMode
    } = savedObjs.props;

    let enteredValue = event.target.value

    //let answer = savedObjs.question.answerText;

    // -----------------------------------------------------------------------------------------------------------------
    // Special handling for From/To date stored as a comma delimited From/To
    // if ((callerRefStr === "dateRangeEntryFrom")||(callerRefStr === "dateRangeEntryTo")) {
    //     debugger;
    //     answer = (answer) ? answer.split(",") : ["",""];
    //     enteredValue = (callerRefStr === "dateRangeEntryFrom") ? enteredValue + "," + answer[1] : answer[0]  + "," + enteredValue;
    // }

    // -----------------------------------------------------------------------------------------------------------------

    if (surveyEditMode === portalShared.EDITABLE_SURVEY) {

        if (savedObjs.question.questionType === portalShared.ADDRESS_FULL) {

            // -----------------------------------------------------------------------------------------------------------------
            // Special Handling for Address (Complex Question Type)

            let addressObj = (displayMode === portalShared.INSTANT_MODE) ? savedObjs.question.addressAnswerDTO : savedObjs.question.addressAnswer;

            let addressAnswer = portalShared.objExists(addressObj) ? {...addressObj} : {address: "", extended: "", city: "", zipPostalCode: ""};
            //let addressAnswerSave = {...addressAnswer};

            addressAnswer[callerRefStr.substring(8)] = enteredValue;

            if (displayMode === portalShared.INSTANT_MODE) {
                savedObjs.props.answerQuestionText(question, {addressAnswer: addressAnswer}, "text", callerRefStr);
            }
            else {
                savedObjs.props.answerQuestionTemplateText(question, {addressAnswer: addressAnswer}, "text", callerRefStr);
            }
            //}
        }
        else {

            // See if template or instance
            if (displayMode === portalShared.INSTANT_MODE) {
                enteredValue = question.questionType === portalShared.DATE_RANGE ? question.answerText : enteredValue;
                savedObjs.props.answerQuestionText(question, {answerText: enteredValue}, "text", callerRefStr);
            } else {
                savedObjs.props.answerQuestionTemplateText(question, {answerText: enteredValue}, "text", callerRefStr);
            }
        }

    }
}


//</editor-fold>
// ---------------------------------------------------------------------------------------------------------------------
// |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||


// |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||
// ---------------------------------------------------------------------------------------------------------------------
//<editor-fold desc="[CODE SECTION] Text Entry Fields (QUESTION) -------------------------------------------------------------------------">


export function textEntryQuestion(textEntryType, inputType, itemObj, props) {
    //const self = this;
    const {questionnaire, question, questionNumber, surveyEditMode, displayMode, answerQuestionOptions, answerQuestionTemplateOptions} = this.props;

    let textObj = ddo.getQuestionNameText(question, questionNumber);

    // Used for state DDLB in address  ---------------------------------------------------------------------------------
    let answers = [];
    let selectedAnswer = null;

    if (inputType === "address") {
        answers = ddo.getAnswerOptions(question);
        selectedAnswer = answers.find((answerOption) => {
            return answerOption.selected === true;
        });

        if (!selectedAnswer) {
            selectedAnswer = {
                id: ""
            };
        }
    }
    // -----------------------------------------------------------------------------------------------------------------

    let savedObjs = {
        itemObj: itemObj,
        inputType: inputType,
        textEntryType: textEntryType,
        inputModifier: "",
        questionnaire: questionnaire,
        question: question,
        questionNameHidden: (tag.metadataValue(question, portalShared.CUSTOM_DDO_NAME) === "hide"),
        questionNumber: questionNumber === "0" ? "" : questionNumber,
        questionTextObj: textObj,
        answerText: "",
        error: false,
        answers: answers, // Used for states DDLB in address
        answerQuestionOptions: answerQuestionOptions,
        answerQuestionTemplateOptions: answerQuestionTemplateOptions,
        selectedAnswer: selectedAnswer, // Used for states DDLB in address
        displayMode: displayMode,
        surveyEditMode: surveyEditMode,
        readonlyMode: (surveyEditMode === portalShared.READONLY_SURVEY),
        //indent: tag.metadataValue(activeTemplate, portalShared.INDENT_LIKERT_QUESTION_NAME, "", "0px"),
        props: props
    }


    if (tag.metadataExistsObj(question, portalShared.CUSTOM_DDO_QUE_FORMAT)) {

        savedObjs.customTemplateObj = tag.metadataValueObj(question, portalShared.CUSTOM_DDO_QUE_FORMAT);

        savedObjs.customTemplateObj.minRows = parseInt(savedObjs.customTemplateObj.minRows); // Update min rows from string to numeric

        if (savedObjs.customTemplateObj.version < 2) {
            savedObjs.customTemplateObj.textStyle = "default";
            savedObjs.customTemplateObj.indent = "0px";
            savedObjs.customTemplateObj.label2 = "";

            savedObjs.customTemplateObj.minRows = parseInt(savedObjs.customTemplateObj.minRows);

            savedObjs.customTemplateObj.text.fontSize = savedObjs.customTemplateObj.text.fontSize ?? "12pt";
            savedObjs.customTemplateObj.text.fontSizeEntry = savedObjs.customTemplateObj.text.fontSizeEntry ?? "12";
            savedObjs.customTemplateObj.text.variant = savedObjs.customTemplateObj.text.variant ?? "caption";

            portalShared.setColor(savedObjs.customTemplateObj.unselectedFloatingLabel, portalShared.COLOR_GRAY_INDEX, portalShared.COLOR_GRAY_HEX);
            portalShared.setColor(savedObjs.customTemplateObj.selectedFloatingLabel, portalShared.COLOR_DEFAULT_BLUE_INDEX, portalShared.COLOR_DEFAULT_BLUE_HEX);
            portalShared.setColor(savedObjs.customTemplateObj.hoverFloatingLabel, portalShared.COLOR_DEFAULT_BLUE_INDEX, portalShared.COLOR_DEFAULT_BLUE_HEX);

            portalShared.setColor(savedObjs.customTemplateObj.placeHolder, portalShared.COLOR_GRAY_INDEX, portalShared.COLOR_GRAY_HEX);

            portalShared.setColor(savedObjs.customTemplateObj.text.colorObj, portalShared.COLOR_GRAY_INDEX, portalShared.COLOR_GRAY_HEX);

            savedObjs.customTemplateObj.unselectedText = {...portalShared.customColorObject};
            savedObjs.customTemplateObj.selectedText = {...portalShared.customColorObject};
            savedObjs.customTemplateObj.hoverText = {...portalShared.customColorObject};

            savedObjs.customTemplateObj.unselectedBorder = {...portalShared.customColorObject};
            savedObjs.customTemplateObj.selectedBorder = {...portalShared.customColorObject};
            savedObjs.customTemplateObj.hoverBorder = {...portalShared.customColorObject};

            portalShared.setColor(savedObjs.customTemplateObj.unselectedBorder, portalShared.COLOR_GRAY_INDEX, portalShared.COLOR_GRAY_HEX);
            portalShared.setColor(savedObjs.customTemplateObj.selectedBorder, portalShared.COLOR_DEFAULT_BLUE_INDEX, portalShared.COLOR_DEFAULT_BLUE_HEX);
            portalShared.setColor(savedObjs.customTemplateObj.hoverBorder, portalShared.COLOR_DEFAULT_BLUE_INDEX, portalShared.COLOR_DEFAULT_BLUE_HEX);

            savedObjs.customTemplateObj.hoverBorderWidth = "1px";

            portalShared.setColor(savedObjs.customTemplateObj.unselectedText, portalShared.COLOR_DEFAULT_BLUE_INDEX, portalShared.COLOR_DEFAULT_BLUE_HEX);
            portalShared.setColor(savedObjs.customTemplateObj.selectedText, portalShared.COLOR_DEFAULT_BLUE_INDEX, portalShared.COLOR_DEFAULT_BLUE_HEX);
            portalShared.setColor(savedObjs.customTemplateObj.hoverText, portalShared.COLOR_DEFAULT_BLUE_INDEX, portalShared.COLOR_DEFAULT_BLUE_HEX);

            portalShared.setColor(savedObjs.customTemplateObj.unselectedBackground, portalShared.COLOR_WHITE_INDEX, portalShared.COLOR_WHITE_HEX);
            portalShared.setColor(savedObjs.customTemplateObj.selectedBackground, portalShared.COLOR_WHITE_INDEX, portalShared.COLOR_WHITE_HEX);
            portalShared.setColor(savedObjs.customTemplateObj.hoverBackground, portalShared.COLOR_WHITE_INDEX, portalShared.COLOR_WHITE_HEX);
        }

        portalShared.matchObj(portalShared.getCustomQuestionTextObj(textEntryType), savedObjs.customTemplateObj);

    } else {
        if (textEntryType === portalShared.ADDRESS_FULL) {
            savedObjs.customTemplateObj = portalShared.getCustomQuestionAddressObj(); // force push DEFAULT ADDRESS
        } else {
            savedObjs.customTemplateObj = portalShared.getCustomQuestionTextObj(question.questionType); // All text types use the same custom object except ADDRESS_FULL
        }
    }

    if (tag.metadataExistsObj(question, portalShared.CUSTOM_DDO_QUE_LABEL)) {
        savedObjs.customLabelObj = tag.metadataValueObj(question, portalShared.CUSTOM_DDO_QUE_LABEL);
    }

    let htmlObj = "";

    switch(textEntryType) {
        case portalShared.FREE_TEXT:
        case portalShared.DATE:
        case portalShared.DATE_RANGE:
            htmlObj = freeTextEntry(savedObjs);
            break;
        case portalShared.EMAIL:
            htmlObj = emailTextEntry(savedObjs);
            break;
        case portalShared.ZIPPOSTAL_ONLY:
        case portalShared.PHONE:
        case portalShared.NUMBER:
        case portalShared.CURRENCY:
            htmlObj = numericTextEntry(savedObjs);
            break;
        case portalShared.ADDRESS_FULL:
            htmlObj = addressAnswerEntry(savedObjs, props);
            break;
        // no default
    }

    return htmlObj;
}




// sx={{input: {color: "red", "&:hover": {color: "red"}}}}

//</editor-fold>
// ---------------------------------------------------------------------------------------------------------------------
// |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||


// ---------------------------------------------------------------------------------------------------------------------
// Free Text Entry
// ---------------------------------------------------------------------------------------------------------------------

const freeTextEntryOnChange = (savedObjs, event) => {

    if (savedObjs.readonlyMode) {
        return;
    }

    let helperText = [""];

    // Added to make un-answer text fields work
    if (savedObjs.question.questionType === portalShared.ADDRESS_FULL) {

        let addressObj = (savedObjs.displayMode === portalShared.INSTANT_MODE) ? savedObjs.question.addressAnswerDTO : savedObjs.question.addressAnswer;

        let addressAnswer = portalShared.objExists(addressObj) ? {...addressObj} : {address: "", extended: "", city: "", zipPostalCode: ""};

        let splitNameArray = event.target.id.split("-");

        addressAnswer[splitNameArray[1]] = event.target.value;

        if (savedObjs.displayMode === portalShared.INSTANT_MODE) {
            savedObjs.props.answerQuestionTextInStore(savedObjs.question, {addressAnswer: addressAnswer, name: splitNameArray[1]}, "text", "freeTextEntryOnChange");
        }
        else {
            savedObjs.props.answerQuestionTemplateText(savedObjs.question, {addressAnswer: addressAnswer, name: splitNameArray[1]}, "text", "freeTextEntryOnChange");
        }

    } else {
        if (savedObjs.displayMode === portalShared.INSTANT_MODE) {
            savedObjs.props.answerQuestionTextInStore(savedObjs.question, {answerText: event.target.value, name: event.target.id}, "text", "freeTextEntryOnChange");
        }
        else {
            savedObjs.props.answerQuestionTemplateText(savedObjs.question, {answerText: event.target.value, name: event.target.id}, "text", "freeTextEntryOnChange");
        }
    }


    // EMAIL warning even if NOT required, but if required then will also have to disable NEXT and SUBMIT buttons
    if (savedObjs.question.questionType === portalShared.EMAIL) {
        let errorObj = validateEmail(event.target.value.trim());
        helperText = [errorObj.message];
    }


    if (savedObjs.question.questionType === portalShared.PHONE) {
        let phoneNum = event.target.value.trim();
        helperText = ((phoneNum.length === 0) || (phoneNum.length >= 10)) ? [""] : ["10 digits required"];
    }


    if (savedObjs.question.questionType === portalShared.ZIPPOSTAL_ONLY) {
        let zip = event.target.value.trim();
        helperText = zip.length >= 5 ? [""] : ["5 digits required"];
    }


    if (savedObjs.question.questionType === portalShared.DATE_RANGE) {

        // dateRangeEntryFrom-date-range
        let answers = savedObjs.question.answerText ? savedObjs.question.answerText.split(",") : ["",""];

        // If ateRangeEntryTo i.e. answers[0] is blank and this is dateRangeEntryFrom then still needs to date
        if (event.target.id.includes("dateRangeEntryFrom")) {

            // DATE answer is formatted FromDate,ToDate
            if ((event.target.value !== "") && (answers.length === 2) && (answers[1] !== "")) {

                if (event.target.value >= answers[1]) {
                    helperText = ["","Date required"]; // FROM/START date missing
                } else {
                    helperText = ["",""];
                }

            } else {
                helperText = ["","Date required"]; // TO/END Date missing
            }

        } else if (event.target.id.includes("dateRangeEntryTo")) {

            if ((event.target.value !== "") && (answers[0] !== "")) {

                if (answers[0] >= event.target.value) {
                    helperText = ["","Date must be later than the other date"]; // FROM missing
                } else {
                    helperText = ["",""];
                }

            } else {
                helperText = ["Date required",""]; // FROM/START date missing
            }

        }

    }


    if (savedObjs.question.questionType === portalShared.ADDRESS_FULL) {

        let statesArray = (savedObjs.displayMode === portalShared.INSTANT_MODE) ? savedObjs.question.answerOptions : savedObjs.question.answerOptionTemplates;

        helperText = ["","","","",""]; // Index 1 is address extended which is NEVER required.

        // NOTE: template does not have property addressAnswer until one of the fields is answered
        if (savedObjs.question.hasOwnProperty((savedObjs.displayMode === portalShared.INSTANT_MODE) ? "addressAnswerDTO" : "addressAnswer")) {

            let addressObjName = (savedObjs.displayMode === portalShared.INSTANT_MODE) ? "addressAnswerDTO" : "addressAnswer";

            let a = portalShared.objExists(savedObjs.question[addressObjName]) ? savedObjs.question[addressObjName] : {address: "", extended: "", city: "", zipPostalCode: ""};
            //let stateSelected = false;

            helperText[0] = a.address.trim() === "" ? "Required" : "";
            helperText[1] = ""; // extended address not required
            helperText[2] = a.city.trim() === "" ? "Required" : "";
            helperText[3] = statesArray.some(state => state.selected) ? "" : "Required.";

            let splitNameArray = event.target.id.split("-");

            let zipFieldValue = a.zipPostalCode;
            if (splitNameArray[1] === "zipPostalCode") {
                zipFieldValue = event.target.value;
            }

            if (zipFieldValue.trim() === "") {
                helperText[4] = "Required";
            }
            else if (zipFieldValue.trim().length !== 5) {
                helperText[4] = "5 digits required";
            } else {
                helperText[4] = "";
            }
        } else {
            helperText = ["Required.","","Required.","Required.","Required."]
        }

        if (statesArray.some(state => state.selected)) {
            helperText[3] = "";
        }

        if (event.target.id !== undefined){
            if (event.target.id.includes("address-address")) {
                helperText[0] = (event.target.value.trim() === "") ? "Required." : "";
            } else if (event.target.id.includes("address-extended")) {
                helperText[1] = ""; // Always blank, NEVER required
            } else if (event.target.id.includes("address-city")) {
                helperText[2] = (event.target.value.trim() === "") ? "Required." : "";
            }

        } else {
            // For some reason zip only sends an event.value, NOT the full event
            if (event.target.value.trim() === "") {
                helperText[4] = "Required.";
            } else if (event.target.value.trim().length !== 5) {
                helperText[4] = "5 digits required";
            } else {
                helperText[4] = "";
            }
        }

    }

    if (!savedObjs.question.optional) {

        if (savedObjs.question.questionType === portalShared.EMAIL ||
            savedObjs.question.questionType === portalShared.PHONE ||
            savedObjs.question.questionType === portalShared.ZIPPOSTAL_ONLY) {

            // If Entry field not valid
            if (helperText[0] !== "") {
                savedObjs.props.onChangeQuestionText(savedObjs.question, savedObjs.question.id, "", helperText); // Force required and "*" in title
            } else {
                savedObjs.props.onChangeQuestionText(savedObjs.question, savedObjs.question.id, event.target.value.trim(), helperText);
            }

        } else if (savedObjs.question.questionType === portalShared.DATE_RANGE) {

            // If both to/start and from/end date OK
            if (helperText[0] !== "" || helperText[1] !== "") {
                savedObjs.props.onChangeQuestionText(savedObjs.question, savedObjs.question.id, "", helperText); // Force required and "*" in title
            } else {
                savedObjs.props.onChangeQuestionText(savedObjs.question, savedObjs.question.id, event.target.value.trim(), helperText);
            }

        } else if (savedObjs.question.questionType === portalShared.ADDRESS_FULL) {

            // All address fields, address is NOT required so [1] should always be blank
            if (helperText[0] !== "" || helperText[1] !== "" || helperText[2] !== "" || helperText[3] !== "" || helperText[4] !== "") {
                savedObjs.props.onChangeQuestionText(savedObjs.question, savedObjs.question.id, "", helperText); // Force required and "*" in title
            } else {
                savedObjs.props.onChangeQuestionText(savedObjs.question, savedObjs.question.id, event.target.value.trim(), helperText);
            }

        } else if (savedObjs.question.questionType === portalShared.PHONE) {

            // If PHONE not 10 digits
            if (helperText[0] !== "") {
                savedObjs.props.onChangeQuestionText(savedObjs.question, savedObjs.question.id, "", helperText); // Force required and "*" in title
            } else {
                savedObjs.props.onChangeQuestionText(savedObjs.question, savedObjs.question.id, event.target.value.trim(), helperText);
            }

        }
        else {
            savedObjs.props.onChangeQuestionText(savedObjs.question, savedObjs.question.id, event.target.value.trim(), helperText);
        }

    }
}


function freeTextEntry(savedObjs, addressFieldName, callerRefStrOverride = "", helperTextIndex = 0) {
    let self = this;
debugger;
    let textPropsObj = getTextProperties(savedObjs, addressFieldName);

    let textStyleObj = font.getDefaultOrCustomTextObj(savedObjs, savedObjs.question, ddo.OBJ_TYPE.TEXT, ddo.OBJ_TEXT_TYPE.NAME);

    //let styledObj = getCustomStyledTextField(savedObjs, textPropsObj, textStyleObj);

    //let additionalProps = getTextField(self, savedObjs, "freetext", textPropsObj, textStyleObj, styledObj, callerRefStrOverride);
    let additionalProps = getTextField(self, savedObjs, "freetext", textPropsObj, textStyleObj, null, (savedObjs.inputType === "date-range" ? "dateRangeEntryFrom" : callerRefStrOverride), helperTextIndex);

    let additionalProps2 = null;
    if (savedObjs.inputType === "date-range") {
        additionalProps2 = getTextField(self, savedObjs, "freetext", textPropsObj, textStyleObj, null, "dateRangeEntryTo", 1);
    }

    let type = (savedObjs.inputType === "date" || savedObjs.inputType === "date-range") ? "date" : savedObjs.inputType;

    // let inputLabelPropsObj = (type === "date") ? {shrink: true} : {};

    // -----------------------------------------------------------------------------------------------------------------
    // CODE FOR DATE RANGE ---------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------------------

    let arrangeSideBySide = false;

    if (savedObjs.hasOwnProperty("customTemplateObj")) {
        arrangeSideBySide = (savedObjs.customTemplateObj.arrangeDateRange === "side");
    }

    let tempStyle = arrangeSideBySide ? {display: "flex", flexDirection: "row", width: "100%"} : {display: "block", width: "100%"};

    // -----------------------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------------------

    return (
        <FormControl key={savedObjs.question.id + "-" + addressFieldName} style={{width: textPropsObj.width}}>

            <div style={tempStyle}>
                <div>

                    {addLabel(savedObjs, LABEL_ABOVE)}
                    <TextField
                        type={type}
                        label={textPropsObj.floatingLabel.text ? textPropsObj.floatingLabel.text : textPropsObj.floatingLabel}
                        name={textPropsObj.placeholder.text ? textPropsObj.placeholder.text : textPropsObj.placeholder}
                        variant={textPropsObj.variant}
                        size={textPropsObj.size}
                        {...{...additionalProps, label: textPropsObj.floatingLabel !== "" ? textPropsObj.floatingLabel : ""}}

                        onChange={freeTextEntryOnChange.bind(self, savedObjs)}
                    />
                    {addLabel(savedObjs, LABEL_BELOW)}

                </div>

                <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>

                {savedObjs.inputType === "date-range" ?

                    <div>

                        {addLabel(savedObjs, LABEL_ABOVE, true)}
                        <TextField
                            type={type}
                            variant={textPropsObj.variant}
                            size={textPropsObj.size}
                            {...{...additionalProps2, label: textPropsObj.floatingLabel2 !== "" ? textPropsObj.floatingLabel2 : ""}}

                            onChange={freeTextEntryOnChange.bind(self, savedObjs)}
                        />
                        {addLabel(savedObjs, LABEL_BELOW, true)}
                    </div> : ""
                }
            </div>
        </FormControl>
    );
}


// ---------------------------------------------------------------------------------------------------------------------
// eMail Text Entry
// ---------------------------------------------------------------------------------------------------------------------


function validateEmail(answerText) {
    // regex checks for one and only 1 '@'
    // no white space in the email
    // at least one character before the '@', between the '@' and the '.'
    // and one or more characters after the '.'

    let validEmailObj = requiredUtil.validateEmail(answerText);

    // let tempEmail = (answerText === null || answerText === undefined) ? "" : answerText;

    // let errorFlag = !!(tempEmail.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/) || tempEmail.length === 0);

    // let errorMessage = !errorFlag ? "Invalid email entry" : "";

    return validEmailObj;
}


function emailTextEntry(savedObjs)  {
    let self = this;

    let textPropsObj = getTextProperties(savedObjs);

    let textStyleObj = font.getDefaultOrCustomTextObj(savedObjs, savedObjs.question, ddo.OBJ_TYPE.TEXT, ddo.OBJ_TEXT_TYPE.NAME);

    //let styledObj = getCustomStyledTextField(savedObjs, textPropsObj, textStyleObj);

    //textPropsObj.errorFunction = validateEmail;

    let additionalProps = getTextField(self, savedObjs, "email", textPropsObj, textStyleObj, null, "");

    return (
        <FormControl key={savedObjs.question.id} style={{width: textPropsObj.width}}>
            {addLabel(savedObjs, LABEL_ABOVE)}
            <TextField
                name={textPropsObj.placeholder}
                variant={textPropsObj.variant}
                size={textPropsObj.size}
               {...{...additionalProps, label: textPropsObj.floatingLabel !== "" ? textPropsObj.floatingLabel : "Email"}}

                onChange={freeTextEntryOnChange.bind(self, savedObjs)}
            />
            {addLabel(savedObjs, LABEL_BELOW)}
        </FormControl>
    );
}


// ---------------------------------------------------------------------------------------------------------------------
// Number Entry
// ---------------------------------------------------------------------------------------------------------------------


function NumberFormatCustom(props) {

    const { inputRef, onChange, ...other } = props;

    //Field name is used to pass a formatted object because it was the only string I could attach too
    let parsedName = JSON.parse(other.name);

    if (parsedName.format === "") {
        return (<NumericFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value, id: other.id
                    }
                });
            }}
            type={parsedName.type}
            decimalScale={parsedName.decimalScale}
            fixedDecimalScale
            thousandSeparator={parsedName.thousandSeparator}
            allowNegative={parsedName.allowNegative}
            prefix={parsedName.prefix}
            suffix={parsedName.suffix}
        />);
    }
    else
    {
        return (<PatternFormat
            placeholder="ZIP Code"
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value, id: other.id
                    }
                });
            }}
            type={parsedName.type}
            format={parsedName.format}
            // allowEmptyFormatting mask={parsedName.mask}
            decimalScale={parsedName.decimalScale}
            thousandSeparator={parsedName.thousandSeparator}
            prefix={parsedName.prefix}
            suffix={parsedName.suffix}
        />);
    }
}


function numericTextEntry(savedObjs, addressFieldName, callerRefStrOverride = "", helperTextIndex = 0) {
    let self = this;

    let textPropsObj = getTextProperties(savedObjs, addressFieldName);

    // NOTE: since name property is passed to the formatter I use it to pass properties in an object
    let name = {thousandSeparator: true, decimalScale: 0, allowNegative: false, prefix: "", suffix: "", type: "text", format: "", mask: ""};

    switch(savedObjs.textEntryType) {
        case portalShared.NUMBER:
            name.suffix = textPropsObj.isPercentage ? "%" : "";
            name.decimalScale = textPropsObj.isDecimal ? textPropsObj.decimalScale : 0;
            name.thousandSeparator = textPropsObj.thousandSeparator;
            name.allowNegative = textPropsObj.allowNegative
            // name.format = tag.metadataValue(savedObjs.question, portalShared.CUSTOM_MASK, "", "")
            break;
        case portalShared.CURRENCY:
            name.decimalScale = textPropsObj.isDecimal ? textPropsObj.decimalScale : 0;
            name.prefix = "$";
            break;
        case portalShared.ZIPPOSTAL_ONLY:
        case portalShared.ADDRESS_FULL:
            //allows for placeholder to show up for zipFormat of 9 and then overrides it when typed.
            name.format = textPropsObj.zipFormat.length > 5 && savedObjs.question.answerText.trim().length > 0
                ? textPropsObj.zipFormat : "#####";
            name.mask = ""
            break;
        case portalShared.PHONE:
            name.type = "tel";
            name.format = "(###) ###-####";
            name.mask = ""
            break;
        // no default
    }

    let textStyleObj = font.getDefaultOrCustomTextObj(savedObjs, savedObjs.question, ddo.OBJ_TYPE.TEXT, ddo.OBJ_TEXT_TYPE.NAME);

    let styleObj = {
        fontSize: textStyleObj.fontObj.fontSize,
        fontStyle: textStyleObj.fontObj.fontStyle,
        fontWeight: textStyleObj.fontObj.fontWeight,
        fontFamily: textStyleObj.fontObj.fontFamily,
    }


    let callerRefStr = callerRefStrOverride !== "" ? callerRefStrOverride : ("numericEntry-" + textPropsObj.type);

    let answerText = portalShared.objExists(savedObjs.question.answerText) ? savedObjs.question.answerText : "";

    let additionalProps = getTextField(self, savedObjs, "email", textPropsObj, textStyleObj, null, callerRefStrOverride, helperTextIndex);

    // If an address field then just pull the required field out
    if (savedObjs.question.questionType === portalShared.ADDRESS_FULL) {
        if (portalShared.objExists(savedObjs.question.addressAnswerDTO))  {
            answerText = savedObjs.question.addressAnswerDTO[callerRefStrOverride.substring(8)];
        }

        if (portalShared.objExists(savedObjs.question.addressAnswer))  {
            answerText = savedObjs.question.addressAnswer[callerRefStrOverride.substring(8)];
        }
    }

    let labelText = portalShared.getLabel[savedObjs.textEntryType].charAt(0).toUpperCase() + portalShared.getLabel[savedObjs.textEntryType].slice(1).toLowerCase();

    // Added to keep floating label to float when formatted data is entered
    let shrinkProp = "";
    if (answerText !== "") {
        shrinkProp = {shrink: true};
    }

    return (
        <FormControl key={savedObjs.question.id} style={{width: textPropsObj.width}}>
            {addLabel(savedObjs, LABEL_ABOVE)}
            <TextField
                id={callerRefStr + "-" + savedObjs.question.id}
                name={JSON.stringify(name)}
                label={textPropsObj.floatingLabel !== "" ? textPropsObj.floatingLabel : labelText}
                placeholder={textPropsObj.placeholder}
                variant={textPropsObj.variant}
                size={textPropsObj.size}
                onBlur={saveAnswerTypeText.bind(self, callerRefStr, savedObjs)}
                min={"0"}
                max={"100"}
                disabled={savedObjs.readonlyMode}
                //inputProps={{autoComplete: "off"}}

                InputProps={{
                    inputComponent: NumberFormatCustom,
                    autoComplete: callerRefStrOverride === "address-zipPostalCode" ? "new-password" : "off",

                }}
                InputLabelProps={{...shrinkProp, style: {...styleObj}}}

                {...{...additionalProps}}

                onChange={freeTextEntryOnChange.bind(self, savedObjs)}

            />
            {addLabel(savedObjs, LABEL_BELOW)}
        </FormControl>
    );
}

// ---------------------------------------------------------------------------------------------------------------------
// Address Entry
// ---------------------------------------------------------------------------------------------------------------------


export function addressAnswerEntry(savedObjs){

    let portalPreviewMode = (savedObjs.displayMode === portalShared.TEMPLATE_MODE);

    const defaultLabels = ["Street 1", "Street 2", "City", "State", "ZIP Code"];
    const customAddressObjNames = ["street1Obj", "street2Obj", "cityObj", "stateObj", "zipObj"];

    let addressObjects = [];

    const cloneObject = (obj) => obj !== null && typeof obj === "object" ? {...obj} : obj;

    const cloneCustomTemplateObjForAddressField = (propName) => ({
        ...savedObjs.customTemplateObj,
        text: cloneObject(savedObjs.customTemplateObj.text),
        selectedFloatingLabel: cloneObject(savedObjs.customTemplateObj.selectedFloatingLabel),
        unselectedFloatingLabel: cloneObject(savedObjs.customTemplateObj.unselectedFloatingLabel),
        hoverFloatingLabel: cloneObject(savedObjs.customTemplateObj.hoverFloatingLabel),
        placeHolder: cloneObject(savedObjs.customTemplateObj.placeHolder),
        placeHolderColor: cloneObject(savedObjs.customTemplateObj.placeHolderColor),
        selectedText: cloneObject(savedObjs.customTemplateObj.selectedText),
        unselectedText: cloneObject(savedObjs.customTemplateObj.unselectedText),
        hoverText: cloneObject(savedObjs.customTemplateObj.hoverText),
        selectedBorder: cloneObject(savedObjs.customTemplateObj.selectedBorder),
        unselectedBorder: cloneObject(savedObjs.customTemplateObj.unselectedBorder),
        hoverBorder: cloneObject(savedObjs.customTemplateObj.hoverBorder),
        ddlbBorderColorAfterSelection: cloneObject(savedObjs.customTemplateObj.ddlbBorderColorAfterSelection),
        [propName]: cloneObject(savedObjs.customTemplateObj[propName])
    });

    const cloneSavedObjsForAddressField = (propName) => ({
        ...savedObjs,
        props: {...savedObjs.props},
        customTemplateObj: cloneCustomTemplateObjForAddressField(propName)
    });

    defaultLabels.forEach((label, index) => {

        let propName = customAddressObjNames[index];
        let clonedObj = cloneSavedObjsForAddressField(propName);

        if (customAddressObjNames[index] !== "stateObj") {
            clonedObj.props.answerQuestionOptions = savedObjs.props.answerQuestionOptions;
            clonedObj.props.answerQuestionTemplateOptions = savedObjs.props.answerQuestionTemplateOptions;
            clonedObj.props.answerQuestionTemplateText = savedObjs.props.answerQuestionTemplateText;
            clonedObj.props.answerQuestionText = savedObjs.props.answerQuestionText;
            clonedObj.props.answerQuestionTextInStore = savedObjs.props.answerQuestionTextInStore;
            clonedObj.props.onChangeQuestionText = savedObjs.props.onChangeQuestionText;

            clonedObj.customTemplateObj[propName].floatingLabel = {text: savedObjs.customTemplateObj[propName].floatingLabel.text, ...clonedObj.customTemplateObj.selectedFloatingLabel};
            clonedObj.customTemplateObj.unselectedFloatingLabel = {text: clonedObj.customTemplateObj[propName].floatingLabel.text, ...clonedObj.customTemplateObj.unselectedFloatingLabel};
            clonedObj.customTemplateObj[propName].placeHolder = {text: clonedObj.customTemplateObj[propName].placeHolder, ...clonedObj.customTemplateObj.placeHolderColor};

        } else {
            clonedObj.answerQuestionOptions = savedObjs.props.answerQuestionOptions;
            clonedObj.answerQuestionTemplateOptions = savedObjs.props.answerQuestionTemplateOptions;
            clonedObj.answerQuestionTemplateText = savedObjs.props.answerQuestionTemplateText;
            clonedObj.answerQuestionText = savedObjs.props.answerQuestionText;
            clonedObj.answerQuestionTextInStore = savedObjs.props.answerQuestionTextInStore;

            clonedObj.customTemplateObj[propName].floatingLabel = {text: savedObjs.customTemplateObj[propName].floatingLabel.text, ...clonedObj.customTemplateObj.selectedFloatingLabel};
            clonedObj.customTemplateObj.unselectedFloatingLabel = {text: savedObjs.customTemplateObj[propName].floatingLabel.text, ...clonedObj.customTemplateObj.unselectedFloatingLabel};
            clonedObj.customTemplateObj[propName].placeHolder = {text: clonedObj.customTemplateObj[propName].placeHolder, ...clonedObj.customTemplateObj.placeHolderColor};

        }

        clonedObj.customTemplateObj["width"] = savedObjs.customTemplateObj[propName].width;
        clonedObj.customTemplateObj["widthEntry"] = savedObjs.customTemplateObj[propName].widthEntry;
        clonedObj.customTemplateObj["widthType"] = savedObjs.customTemplateObj[propName].widthType;
        clonedObj.customTemplateObj["max"] = savedObjs.customTemplateObj[propName].max;
        clonedObj.customTemplateObj["label"] = savedObjs.customTemplateObj[propName].label;


        if (clonedObj.customTemplateObj.style === "standard") {
            // Fix for style standard entries where state was not aligned in row
            // Adding a hard space floating label fixes
            // QDII-2187 Address condition where state is not aligned
            if (clonedObj.customTemplateObj[propName].floatingLabel.text === "") {
                clonedObj.customTemplateObj[propName].floatingLabel.text = portalShared.NON_BREAKING_SPACE;
            }
        }

        addressObjects.push(clonedObj);
    });

    return (
        <div>
            <div id={"address1-" + savedObjs.question.id} >
                {freeTextEntry(addressObjects[0], customAddressObjNames[0], "address-address", 0)}
            </div>

            <div>{portalShared.NON_BREAKING_SPACE}</div>

            <div id={"address2-" + savedObjs.question.id} >
                {freeTextEntry(addressObjects[1], customAddressObjNames[1], "address-extended", 1)}
            </div>

            <div>{portalShared.NON_BREAKING_SPACE}</div>

            <div style={{width: "100%", justifyContent: "space-between"}}>
                <div id={"city-" + savedObjs.question.id} style={{float: "left"}}>
                    {freeTextEntry(addressObjects[2], customAddressObjNames[2], "address-city", 2)}
                </div>

                <div style={{float: "left", width: portalPreviewMode ? "11px" : "20px"}}>{portalShared.NON_BREAKING_SPACE}</div>

                <div id={"state-" + savedObjs.question.id} style={{float: "left", width: "200px"}}>
                    {addLabel(addressObjects[3], LABEL_ABOVE)}
                    {singleSelectDropDown(addressObjects[3], customAddressObjNames[3], requiredUtil.getHelperText(savedObjs.question.id, savedObjs.props.dataDefObj, 3))}
                    <div style={{marginTop: "-4px"}}>{addLabel(addressObjects[3], LABEL_BELOW)}</div>
                </div>

                <div style={{float: "left", width: portalPreviewMode ? "11px" : "20px"}}>{portalShared.NON_BREAKING_SPACE}</div>

                <div id={"zip-" + savedObjs.question.id} style={{float: "left"}}>
                    {numericTextEntry(addressObjects[4], customAddressObjNames[4], "address-zipPostalCode", 4)}
                </div>
            </div>

        </div>
    );
}


// ---------------------------------------------------------------------------------------------------------------------
// ---------------------------------------------------------------------------------------------------------------------
// Text Entry Utilities
// ---------------------------------------------------------------------------------------------------------------------
// ---------------------------------------------------------------------------------------------------------------------


function addLabel(savedObjs, labelPosition, dateFromFlag = false) {

    // Label check is for addresses because they behave differently
    if (savedObjs.hasOwnProperty("customTemplateObj") && (savedObjs.customTemplateObj.hasOwnProperty("label") || savedObjs.customTemplateObj.hasOwnProperty("label2"))) {

        //let question = savedObjs.question;

        let label = dateFromFlag ? savedObjs.customTemplateObj.label2 : savedObjs.customTemplateObj.label;

        label = (savedObjs.customTemplateObj.labelPosition === labelPosition) ? label : "";

        if (savedObjs.questionNameHidden) {
            return <div></div>;
        }

        // Is there a label
        if (savedObjs.customTemplateObj.labelPosition !== undefined && savedObjs.customTemplateObj.labelPosition !== "none") {

            let customLabelObj = portalShared.getCustomQuestionLabelTextObj();
            if (savedObjs.hasOwnProperty("customLabelObj")) {
                customLabelObj = savedObjs.customLabelObj;
            }

            //let customObj = savedObjs.customTemplateObj.text;

            let CustomTypography = styled(Typography)({
                fontFamily: customLabelObj.fontFamily,
                fontWeight: customLabelObj.fontWeight,
                fontSize: customLabelObj.fontSize,  // 2em, 18pt
                fontStyle: customLabelObj.fontStyle,
                textAlign: customLabelObj.textAlign,  // left center right
                color: portalShared.getColor(customLabelObj.colorObj),
                opacity: portalShared.getOpacity(customLabelObj.colorObj),
            });

            return <CustomTypography>{label}</CustomTypography>;
        }
    }

    return null;
}


function getTextProperties(savedObjs, addressFieldName, defaultWidth = "100%", defaultMaxlength = "80") {

    let textDefObj = {};

    textDefObj.type = savedObjs.inputType;
    textDefObj.floatingLabel = "";
    textDefObj.floatingLabel2 = "";
    textDefObj.placeholder = "";
    textDefObj.variant = "outlined";
    textDefObj.size = "small";
    textDefObj.width = defaultWidth;
    textDefObj.maxLength = defaultMaxlength;
    textDefObj.multiline = false;
    textDefObj.maxRows = 1;
    textDefObj.minRows = 1;
    textDefObj.isPercentage = false;
    textDefObj.allowNegative = false;
    textDefObj.isDecimal = false;
    textDefObj.decimalScale = 2;
    textDefObj.thousandSeparator = true;
    textDefObj.zipFormat = "#####";
    textDefObj.customFormat = "";

    let obj = savedObjs.customTemplateObj;

    if (savedObjs.textEntryType === portalShared.ADDRESS_FULL) {

        textDefObj.zipFormat = obj.zipFormat;
        textDefObj.variant = obj.style;
        textDefObj.size = obj.size;

        obj = obj[addressFieldName]; // Change object to specific address object

        textDefObj.floatingLabel = obj.floatingLabel?.text;
        textDefObj.placeholder = obj.placeHolder?.text;
        textDefObj.width = obj.width;
        textDefObj.maxLength = obj.max;

    } else {

        textDefObj.floatingLabel = obj.unselectedFloatingLabel?.text;
        textDefObj.floatingLabel2 = obj.floatingLabel2;
        textDefObj.placeholder = obj.placeHolder?.text;
        textDefObj.variant = obj.style;
        textDefObj.size = obj.size;
        textDefObj.width = obj.width;
        textDefObj.maxLength = obj.max;
        textDefObj.multiline = obj.multiline;
        textDefObj.maxRows = obj.maxRows;
        textDefObj.minRows = obj.minRows;
        textDefObj.isPercentage = obj.isPercentage;
        textDefObj.allowNegative = obj.isNegative;
        textDefObj.isDecimal = obj.isDecimal;
        textDefObj.decimalScale = obj.decimalScale;
        textDefObj.thousandSeparator = obj.thousandSeparator;
        textDefObj.zipFormat = obj.zipFormat;

    }

    return textDefObj;
}


export function getCustomColor(savedObjs, propName, defaultColor) {

    let color = defaultColor;
    if (savedObjs.hasOwnProperty("customTemplateObj") && savedObjs.customTemplateObj.hasOwnProperty(propName)) {
        color = portalShared.getColor(savedObjs.customTemplateObj[propName]);
    }
    return color;
}

export function getCustomColorObj(savedObjs, propName, defaultColor) {

    let color = defaultColor;
    if (savedObjs.hasOwnProperty("customTemplateObj") && savedObjs.customTemplateObj.hasOwnProperty(propName)) {
        if (savedObjs?.customTemplateObj[propName].hasOwnProperty("colorObj"))
        color = portalShared.getColor(savedObjs?.customTemplateObj[propName].colorObj);
    }
    return color;
}


export function getCustomStyledTextField(savedObjs, textPropsObj, textStyleObj) {

    //let defaultGray = "#808080";
    // Set styledObj defaults
    let styledObj = {
        styledTextField: null,
        styledDateField: null,
        styledSelect: null,
        textColor:  getCustomColorObj(savedObjs, "placeHolder", portalShared.COLOR_GRAY_HEX),
        // textColorHovered: textStyleObj.type === "default" ? portalShared.DEFAULT_TEXT_FIELD_TEXT_COLOR_HOVERED : textStyleObj.fontObj.color,
        // textColorFocused: textStyleObj.type === "default" ? portalShared.DEFAULT_TEXT_FIELD_TEXT_COLOR_FOCUSED : textStyleObj.fontObj.color,
        floatingLabel: savedObjs?.customTemplateObj?.unselectedFloatingLabel?.text,
        floatingLabel2: savedObjs?.customTemplateObj?.floatingLabel2,
        floatingLabelColor: getCustomColor(savedObjs, "unselectedFloatingLabel", portalShared.COLOR_GRAY_HEX),
        floatingLabelColorHovered: getCustomColor(savedObjs, "hoverFloatingLabel", portalShared.COLOR_GRAY_HEX),
        floatingLabelColorFocused: getCustomColor(savedObjs, "selectedFloatingLabel", portalShared.COLOR_GRAY_HEX),

        unselectedText: getCustomColor(savedObjs, "unselectedText", portalShared.COLOR_GRAY_HEX),
        selectedText: getCustomColor(savedObjs, "selectedText", portalShared.COLOR_BLACK_HEX),
        hoverText: getCustomColor(savedObjs, "hoverText", portalShared.COLOR_BLACK_HEX),

        placeHolderColor: getCustomColor(savedObjs, "placeHolder", portalShared.COLOR_GRAY_HEX),
        placeHolderOpacity: portalShared.getOpacity(savedObjs.customTemplateObj.placeHolder),

        colorTextAnsweredBorderColor: getCustomColor(savedObjs, "selectedBorder"),

        backgroundColor: getCustomColor(savedObjs, "unselectedBackground", portalShared.COLOR_WHITE_HEX),
        backgroundColorHovered: getCustomColor(savedObjs, "hoverBackground", portalShared.COLOR_WHITE_HEX),
        backgroundColorFocused: getCustomColor(savedObjs, "selectedBackground", portalShared.COLOR_WHITE_HEX),

        backgroundFilledColor: getCustomColor(savedObjs, "unselectedBackground", portalShared.COLOR_LIGHT_GRAY_HEX),
        backgroundFilledColorHovered: getCustomColor(savedObjs, "hoverBackground", portalShared.COLOR_LIGHT_GRAY_HEX),
        backgroundFilledColorFocused: getCustomColor(savedObjs, "selectedBackground", portalShared.COLOR_LIGHT_GRAY_HEX),

        borderColor: getCustomColor(savedObjs, "unselectedBorder", portalShared.COLOR_GRAY_HEX),
        borderColorHovered: getCustomColor(savedObjs, "hoverBorder", portalShared.COLOR_DEFAULT_BLUE_HEX),
        borderColorFocused: getCustomColor(savedObjs, "selectedBorder", portalShared.COLOR_DEFAULT_BLUE_HEX),
    }

    let tempStyledObj = {
        //Properties for all text fields
        // "& .MuiInputBase-root": {
        //     color: styledObj.textColor //Text color for all text field
        // },
        // "&:hover": {
        //     color: styledObj.hoverText
        // },
        // "& .Mui-focused": {
        //     color: styledObj.selectedText
        // },
        "& .MuiInputLabel-root": {
            color: styledObj.floatingLabelColor // MUI 5 floating label color all variants NOT focused or hovered
        },
        "&:hover label": {
            color: styledObj.floatingLabelColorHovered // MUI 5 floating label color all variants hovered
        },
        "& label.Mui-focused": {
            color: styledObj.floatingLabelColorFocused // MUI 5 floating label color all variants focused
        },

        //All outlined text field properties
        "& .MuiOutlinedInput-root": {
            backgroundColor: styledObj.backgroundColor,
            "& fieldset": {
                borderColor: styledObj.borderColor // MUI 5 outlined border color NOT focused or hovered
            },
            "&:hover fieldset": {
                borderColor: styledObj.borderColorHovered // MUI 5 outlined border color hovered
            },
            "&.Mui-focused fieldset": {
                borderColor: styledObj.borderColorFocused // MUI 5 outlined border color focused
            },
            "&:hover": {
                backgroundColor: styledObj.backgroundColorHovered,
            },
            "&.Mui-focused": {
                backgroundColor: styledObj.backgroundColorFocused,
            }
        },
        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder": {
            font: textStyleObj.fontObj.fontFamily,
            color: styledObj.placeHolderColor,
            opacity: styledObj.placeHolderOpacity
        },

        //All standard text field properties
        "&& .MuiInput-root::before": {
            borderColor: styledObj.borderColor, // MUI 5 standard underline NOT hovered or focused color
        },
        "&& .MuiInput-root:hover::before": {
            borderColor: styledObj.borderColorHovered // MUI 5 standard underline hover color
        },
        "&& .MuiInput-root::after": {
            borderColor: styledObj.borderColorFocused // MUI 5 standard underline focused color
        },
        "& .MuiInputBase-root.MuiInput-root ::placeholder": {
            font: textStyleObj.fontObj.fontFamily,
            color: styledObj.placeHolderColor,
            opacity: styledObj.placeHolderOpacity
        },

        //Background color for standard text field
        //On standard text field the background color blocks floating label
        "& .MuiInput-root": {
            backgroundColor: styledObj.backgroundColor,
            "&:hover": {
                backgroundColor: styledObj.backgroundColorHovered,
            },
            "&.Mui-focused": {
                backgroundColor: styledObj.backgroundColorFocused,
            },
        },

        //All filled text field properties
        "&& .MuiFilledInput-root": {
            backgroundColor: styledObj.backgroundFilledColor,
        },
        "&& .MuiFilledInput-root::before": {
            borderColor: styledObj.borderColor // MUI 5 filled underline NOT hovered or focused color
        },
        "&& .MuiFilledInput-root:hover::before": {
            borderColor: styledObj.borderColorHovered // MUI 5 filled underline hover color
        },
        "&& .MuiFilledInput-root::after": {
            borderColor: styledObj.borderColorFocused // MUI 5 filled underline focused color
        },
        "& .MuiInputBase-root.MuiFilledInput-root ::placeholder": {
            font: textStyleObj.fontObj.fontFamily,
            color: styledObj.placeHolderColor,
            opacity: styledObj.placeHolderOpacity
        },

        //Background colors for filled text field
        "& .MuiFilledInput-root": {
            backgroundColor: styledObj.backgroundFilledColor,
            "&:hover": {
                backgroundColor:styledObj.backgroundFilledColorHovered,
            },
            "&.Mui-focused": {
                backgroundColor: styledObj.backgroundFilledColorFocused,
            }
        },
    };

    styledObj.styledTextField = styled(TextField)(tempStyledObj);

    //styledObj.styledDateField = styled(DateField)(tempStyledObj);

    styledObj.styledSelect = styled(Select)(tempStyledObj);

    return styledObj;
}

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// TextField sx prop for styling
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

function getTextField(self, savedObjs, entryType, textPropsObj, textStyleObj, styledObj, callerRefStrOverride = "", helperTextIndex = 0) {

    let styleObj = {
        fontSize: textStyleObj.fontObj.fontSize,
        fontStyle: textStyleObj.fontObj.fontStyle,
        fontWeight: textStyleObj.fontObj.fontWeight,
        fontFamily: textStyleObj.fontObj.fontFamily,
    }
    //let error = {flag: false, message: ""};    //textPropsObj.errorFunction(savedObjs.question.answerText);

    let callerRefStr = (callerRefStrOverride !== "") ? callerRefStrOverride : ("textEntry-" + textPropsObj.type)

    let answerText = savedObjs.question.answerText ? savedObjs.question.answerText : "";

    // If an address field then just pull the required field out

    if (savedObjs.question.questionType === portalShared.ADDRESS_FULL) {
        if (savedObjs.displayMode === portalShared.INSTANT_MODE) {
            if ((savedObjs?.question?.addressAnswerDTO)) {
                answerText = savedObjs.question.addressAnswerDTO[callerRefStrOverride.substring(8)];
            }
        } else {
            if ((savedObjs?.question?.addressAnswer)) {
                answerText = savedObjs.question.addressAnswer[callerRefStrOverride.substring(8)];
            }
        }
    }

    // if ((callerRefStrOverride.substring(8) === "zipPostalCode")) {
    //     answerText = Number(answerText);
    // }

    if (callerRefStrOverride === "dateRangeEntryFrom") {
        let answerArray = portalShared.objExists(savedObjs.question.answerText) ? savedObjs.question.answerText.split(",") : "";
        answerText = answerArray[0];
    } else if (callerRefStrOverride === "dateRangeEntryTo") {
        let answerArray = portalShared.objExists(savedObjs.question.answerText) ? savedObjs.question.answerText.split(",") : "";
        answerText = (answerArray.length === 2) ? answerArray[1] : "";
    }


    let autoComplete = "off";
    if (callerRefStrOverride !== "") {
        if (callerRefStrOverride.substring(0,8) === "address-") {
            autoComplete = "new-password";
        }
    }

    let width = (savedObjs.hasOwnProperty("customTemplateObj") ? savedObjs.customTemplateObj.width : portalShared.DEFAULT_DATE_ENTRY_WIDTH + "px")

    let type = (savedObjs.inputType === "date" || savedObjs.inputType === "date-range") ? "date" : savedObjs.inputType;

    let shrinkObj = (type === "date") ? {shrink: true} : {};

    if (savedObjs.textEntryType === portalShared.DATE || savedObjs.textEntryType === portalShared.DATE_RANGE) {

        // The only difference is that for dates having value keeps input from working, but numeric fields need it to force floating labels to work.  **ANKOOR FIX **
        // defaultValue: answerText, removed and added a value prop
        return {
            value: answerText,

            id: callerRefStr + "-" + savedObjs.question.id,
            label: textPropsObj.floatingLabel,
            placeholder: textPropsObj.placeholder,
            multiline: textPropsObj.multiline,
            maxRows: textPropsObj.maxRows,
            minRows: textPropsObj.minRows,
            variant: textPropsObj.variant,
            size: textPropsObj.size,
            onBlur: saveAnswerTypeText.bind(self, callerRefStr, savedObjs),
            error: savedObjs.error,
            FormHelperTextProps: {
                sx: {
                    color: "red"
                }
            },
            helperText: requiredUtil.getHelperText(savedObjs.question.id, savedObjs.props.dataDefObj, helperTextIndex),
            disabled: savedObjs.readonlyMode,
            inputProps: {maxLength: textPropsObj.maxLength, tabIndex: savedObjs.props.tabIndex, autoComplete: autoComplete, style: {...styleObj}},
            InputLabelProps: {
                style: {
                    autoComplete: "off", ...styleObj,
                },
                ...shrinkObj
            },
            sx: {...sxObjGet(savedObjs, callerRefStrOverride), width: width},
        }

    }
    else {

        return {
            value: answerText,

            id: callerRefStr + "-" + savedObjs.question.id,
            label: textPropsObj.floatingLabel,
            placeholder: textPropsObj.placeholder,
            multiline: textPropsObj.multiline,
            maxRows: textPropsObj.maxRows,
            minRows: textPropsObj.minRows,
            variant: textPropsObj.variant,
            size: textPropsObj.size,
            onBlur: saveAnswerTypeText.bind(self, callerRefStr, savedObjs),
            error: savedObjs.error,
            FormHelperTextProps: {
                sx: {
                    color: "red"
                }
            },
            helperText: requiredUtil.getHelperText(savedObjs.question.id, savedObjs.props.dataDefObj, helperTextIndex),
            disabled: savedObjs.readonlyMode,
            inputProps: {maxLength: textPropsObj.maxLength, tabIndex: savedObjs.props.tabIndex, autoComplete: autoComplete, style: {...styleObj}},
            InputLabelProps: {
                style: {
                    autoComplete: "off", ...styleObj,
                },
                ...shrinkObj
            },
            sx: {...sxObjGet(savedObjs), width: width},
        }

    }
}

// ---------------------------------------------------------------------------------------------------------------------
// CUSTOM TEXT FIELD (STANDARD, OUTLINED and FILLED)
// ---------------------------------------------------------------------------------------------------------------------

// Empty date and date-range fields use the placeholder color/opacity for their text
function getUnselectedTextStyle(savedObjs, getColor, getOpacity, callerRefStrOverride = "") {
    const obj = savedObjs.customTemplateObj;
    const answerText = savedObjs.question.answerText;
    const parts = answerText ? answerText.split(",") : [];

    let isEmpty = false;
    if (savedObjs.question.questionType === portalShared.DATE) {
        isEmpty = !answerText;
    } else if (savedObjs.question.questionType === portalShared.DATE_RANGE) {
        if (callerRefStrOverride === "dateRangeEntryFrom") {
            isEmpty = !answerText || parts[0] === "";
        } else if (callerRefStrOverride === "dateRangeEntryTo") {
            isEmpty = !answerText || parts.length !== 2;
        } else {
            isEmpty = !answerText;
        }
    }

    return isEmpty
        ? {color: getColor(obj.placeHolder), opacity: getOpacity(obj.placeHolder)}
        : {color: getColor(obj.unselectedText), opacity: getOpacity(obj.unselectedText)};
}

function sxObjGet(savedObjs, callerRefStrOverride = "") {
    let sxObj = {}; // GREAT Web Page for describing sx Text Entry Styling https://muhimasri.com/blogs/mui-textfield-colors-styles/

    // portalShared.setColor(obj.placeHolder, null, "orange", "hex");
    //
    // portalShared.setColor(obj.unselectedFloatingLabel, null, "blue", "hex");
    // portalShared.setColor(obj.selectedFloatingLabel, null, "yellow", "hex");
    // portalShared.setColor(obj.hoverFloatingLabel, null, "purple", "hex");
    //
    // portalShared.setColor(obj.unselectedText, null, "red", "hex");
    // portalShared.setColor(obj.selectedText, null, "green", "hex");
    // portalShared.setColor(obj.hoverText, null, "purple", "hex");
    //
    // portalShared.setColor(obj.unselectedBorder, null, "gray", "hex"); // Y
    // portalShared.setColor(obj.selectedBorder, null, "cyan", "hex");
    // portalShared.setColor(obj.hoverBorder, null, "cyan", "hex"); // Y
    //
    // portalShared.setColor(obj.unselectedBackground, null, "white", "hex"); // Outlined Only
    // portalShared.setColor(obj.selectedBackground, null, "white", "hex"); // Outlined Only
    // portalShared.setColor(obj.hoverBackground, null, "white", "hex"); // Outlined Only
    //
    // obj.borderWidth = "1px";
    // obj.hoverBorderWidth = "1px";
    // obj.selectedBorderWidth = "2px";

    switch (savedObjs.customTemplateObj.style) {
        case "standard":
            sxObj = sxStandardTextField(savedObjs, portalShared.getColor, portalShared.getOpacity, callerRefStrOverride);
            break;
        case "outlined":
            sxObj = sxOutlinedTextField(savedObjs, portalShared.getColor, portalShared.getOpacity, callerRefStrOverride);
            break;
        case "filled":
            sxObj = sxFilledTextField(savedObjs, portalShared.getColor, portalShared.getOpacity, callerRefStrOverride);
            break;
        // no default
    }
    return sxObj;
}

// ---------------------------------------------------------------------------------------------------------------------
// STANDARD TEXT FIELD
// ---------------------------------------------------------------------------------------------------------------------

function sxStandardTextField(savedObjs, getColor, getOpacity, callerRefStrOverride = "") {
    let obj = savedObjs.customTemplateObj;
    const unselectedText = getUnselectedTextStyle(savedObjs, getColor, getOpacity, callerRefStrOverride);

    let sxObj = {
        input: {
            "&::placeholder": {
                color: getColor(obj.placeHolder),
                opacity: getOpacity(obj.placeHolder),

            },
        },
        "& .MuiInput-root": {
            color: unselectedText.color, // unselected text color *
            opacity: unselectedText.opacity,
            // Bottom border
            "&:before": {
                borderColor: getColor(obj.unselectedBorder), // unselected border
                opacity: getOpacity(obj.unselectedBorder),
                borderWidth: obj.borderWidth
            },
            "&.Mui-focused": {
                color: getColor(obj.selectedText),     // focused text color *
                opacity: getOpacity(obj.selectedText), // focused text opacity *
                backgroundColor: portalShared.convertColorObjToRgba(obj.selectedBackground), // focused background color/opacity (convert to rgba() to include opacity) *
            },
            "&:hover:not(.Mui-focused)": {
                color: getColor(obj.hoverText),     // hovered text color *
                opacity: getOpacity(obj.hoverText), // hovered text opacity *
                //backgroundColor: portalShared.convertColorObjToRgba(obj.hoverBackground), // hovered background color/opacity (convert to rgba() to include opacity) *
            },
            // Border on focus
            "&:after": {
                borderColor: getColor(obj.selectedBorder), // selected border
                opacity: getOpacity(obj.selectedBorder),
                borderWidth: obj.selectedBorderWidth
            },
            ":hover:not(.Mui-focused)": {
                "&:before": {
                    borderColor: getColor(obj.hoverBorder), // hover border
                    opacity: getOpacity(obj.hoverBorder),
                    borderWidth: obj.hoverBorderWidth
                },
            },
        },
        // Label
        "& .MuiInputLabel-standard": {
            color: getColor(obj.unselectedFloatingLabel), // unselected floating label
            opacity: getOpacity(obj.unselectedFloatingLabel),
            "&.Mui-focused": {
                color: getColor(obj.selectedFloatingLabel), // selected floating label
                opacity: getOpacity(obj.selectedFloatingLabel)
            },
        },
        "&:hover label": {
            color: getColor(obj.hoverFloatingLabel), // selected floating label
            opacity: getOpacity(obj.hoverFloatingLabel)
        }
    };

    return sxObj;
}


// ---------------------------------------------------------------------------------------------------------------------
// OUTLINED TEXT FIELD
// ---------------------------------------------------------------------------------------------------------------------

function sxOutlinedTextField(savedObjs, getColor, getOpacity, callerRefStrOverride = "") {

    let obj = savedObjs.customTemplateObj;

    const unselectedText = getUnselectedTextStyle(savedObjs, getColor, getOpacity, callerRefStrOverride);

    let sxObj = {
        input: {
            "&::placeholder": {
                color: getColor(obj.placeHolder),
                opacity: getOpacity(obj.placeHolder),

            },
        },
        "& .MuiOutlinedInput-root": {
            color: unselectedText.color,        // unselected text color *
            opacity: unselectedText.opacity,    // unselected text opacity *
            backgroundColor: portalShared.convertColorObjToRgba(obj.unselectedBackground), // unselected background color/opacity (convert to rgba() to include opacity) *
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: getColor(obj.unselectedBorder), // unselected border color *
                opacity: getOpacity(obj.unselectedBorder),   // unselected border opacity *
                borderWidth: obj.borderWidth,                // unselected border width *
            },
            "&.Mui-focused": {
                color: getColor(obj.selectedText),     // focused text color *
                opacity: getOpacity(obj.selectedText), // focused text opacity *
                backgroundColor: portalShared.convertColorObjToRgba(obj.selectedBackground), // focused background color/opacity (convert to rgba() to include opacity) *
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: getColor(obj.selectedBorder), // focused border color *
                    opacity: getOpacity(obj.selectedBorder),   // focused border opacity *
                    borderWidth: obj.selectedBorderWidth,      // focused border width *
                },
            },
            "&:hover:not(.Mui-focused)": {
                color: getColor(obj.hoverText),     // hovered text color *
                opacity: getOpacity(obj.hoverText), // hovered text opacity *
                backgroundColor: portalShared.convertColorObjToRgba(obj.hoverBackground), // hovered background color/opacity (convert to rgba() to include opacity) *
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: getColor(obj.hoverBorder), // hovered border color *
                    opacity: getOpacity(obj.hoverBorder),   // hovered border opacity *
                    borderWidth: obj.hoverBorderWidth,      // hovered border width *
                },
            },
        },
        "& .MuiInputLabel-outlined": {
            backgroundColor: portalShared.convertColorObjToRgba(obj.unselectedBackground),
            color: getColor(obj.unselectedFloatingLabel),     // unselected floating label color *
            opacity: getOpacity(obj.unselectedFloatingLabel), // unselected floating label opacity *
            "&.Mui-focused": {
                color: getColor(obj.selectedFloatingLabel),  // selected floating label color *
                opacity: getOpacity(obj.selectedFloatingLabel),       // selected floating label opacity *
                backgroundColor: portalShared.convertColorObjToRgba(obj.selectedBackground),
            },
        },
        "&:hover label": {
            color: getColor(obj.hoverFloatingLabel), // selected floating label
            opacity: getOpacity(obj.hoverFloatingLabel)
        },
        "&:hover .MuiInputLabel-outlined": {
            backgroundColor: portalShared.convertColorObjToRgba(obj.hoverBackground),
        }
    };

    return sxObj;
}

// ---------------------------------------------------------------------------------------------------------------------
// FILLED TEXT FIELD
// ---------------------------------------------------------------------------------------------------------------------

function sxFilledTextField(savedObjs, getColor, getOpacity, callerRefStrOverride = "") {

    let obj = savedObjs.customTemplateObj;
    const unselectedText = getUnselectedTextStyle(savedObjs, getColor, getOpacity, callerRefStrOverride);

    let sxObj = {
        input: {
            "&::placeholder": {
                color: getColor(obj.placeHolder),
                opacity: getOpacity(obj.placeHolder),
            },
        },
        "& .MuiFilledInput-root": {
            color: unselectedText.color, // unselected text
            opacity: unselectedText.opacity,
            "&:before": {
                borderColor: getColor(obj.unselectedBorder), // unselected border
                opacity: getOpacity(obj.unselectedBorder),
                borderWidth: obj.borderWidth
            },
            "&.Mui-focused": {
                color: getColor(obj.selectedText),     // focused text color *
                opacity: getOpacity(obj.selectedText), // focused text opacity *
                backgroundColor: portalShared.convertColorObjToRgba(obj.selectedBackground), // focused background color/opacity (convert to rgba() to include opacity) *
                // "& .MuiOutlinedInput-notchedOutline": {
                //     borderColor: getColor(obj.selectedBorder), // focused border color *
                //     opacity: getOpacity(obj.selectedBorder),   // focused border opacity *
                //     borderWidth: obj.selectedBorderWidth,      // focused border width *
                // },
            },
            ":hover:not(.Mui-focused)": {
                color: getColor(obj.hoverText), // hover text color
                opacity: getOpacity(obj.hoverText), // hover text opacity
                "&:before": {
                    borderColor: getColor(obj.hoverBorder),
                    borderWidth: getOpacity(obj.hoverBorder),
                },
                // "&:before": {
                //     color: "red",
                //     borderColor: getColor(obj.hoverBorder), // hover border
                //     opacity:  getOpacity(obj.hoverBorder),
                //     borderWidth: obj.hoverBorderWidth
                //
                // },
            },
            // Border on focus
            "&:after": {
                borderColor: getColor(obj.selectedBorder), // selected border
                opacity: getOpacity(obj.selectedBorder),
                borderWidth: obj.selectedBorderWidth
            },

        },
        "& .MuiInputLabel-filled": {
            color: getColor(obj.unselectedFloatingLabel),  // unselected/selected floating label
            opacity: getOpacity(obj.unselectedFloatingLabel),
            "&.Mui-focused": {
                color: getColor(obj.selectedFloatingLabel), // selected floating label
                opacity: getOpacity(obj.selectedFloatingLabel),
            }
        },
        "&:hover label": {
            color: getColor(obj.hoverFloatingLabel), // selected floating label
            opacity: getOpacity(obj.hoverFloatingLabel)
        }
    };

    return sxObj;
}
